module.exports = __webpack_public_path__ + "img/MapThumb_Overpass.8e4a3357.webp";